"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.OnboardingSessionAuthenticationStatusItem = exports.HookSubscriptionEventItem = exports.EmailValidationStatusItem = exports.ConversationChannelItem = void 0;
var ConversationChannelItem;
(function (ConversationChannelItem) {
    ConversationChannelItem["Unknown"] = "Unknown";
    ConversationChannelItem["FacebookMessenger"] = "facebook_messenger";
    ConversationChannelItem["Whatsapp"] = "whatsapp";
    ConversationChannelItem["Sms"] = "sms";
    ConversationChannelItem["Chat"] = "chat";
    ConversationChannelItem["Email"] = "email";
    ConversationChannelItem["Voice"] = "voice";
})(ConversationChannelItem = exports.ConversationChannelItem || (exports.ConversationChannelItem = {}));
var EmailValidationStatusItem;
(function (EmailValidationStatusItem) {
    EmailValidationStatusItem["ServerError"] = "server-error";
    EmailValidationStatusItem["Valid"] = "valid";
    EmailValidationStatusItem["InvalidDisposable"] = "invalid-disposable";
    EmailValidationStatusItem["InvalidFormat"] = "invalid-format";
    EmailValidationStatusItem["AlreadyRegistered"] = "already-registered";
})(EmailValidationStatusItem = exports.EmailValidationStatusItem || (exports.EmailValidationStatusItem = {}));
var HookSubscriptionEventItem;
(function (HookSubscriptionEventItem) {
    HookSubscriptionEventItem["ConversationNew"] = "conversation.new";
    HookSubscriptionEventItem["ConversationCommentNew"] = "conversation.comment.new";
    HookSubscriptionEventItem["ConversationTagged"] = "conversation.tagged";
    HookSubscriptionEventItem["ConversationReplyNew"] = "conversation.reply.new";
    HookSubscriptionEventItem["ConversationSnoozeExpired"] = "conversation.snooze.expired";
    HookSubscriptionEventItem["ConversationAssigned"] = "conversation.assigned";
    HookSubscriptionEventItem["ContactNewOrUpdated"] = "contact.new_or_updated";
})(HookSubscriptionEventItem = exports.HookSubscriptionEventItem || (exports.HookSubscriptionEventItem = {}));
var OnboardingSessionAuthenticationStatusItem;
(function (OnboardingSessionAuthenticationStatusItem) {
    OnboardingSessionAuthenticationStatusItem["ServerError"] = "server-error";
    OnboardingSessionAuthenticationStatusItem["Valid"] = "valid";
    OnboardingSessionAuthenticationStatusItem["AlreadyFinalized"] = "already-finalized";
    OnboardingSessionAuthenticationStatusItem["Invalid"] = "invalid";
    OnboardingSessionAuthenticationStatusItem["Forbidden"] = "forbidden";
})(OnboardingSessionAuthenticationStatusItem = exports.OnboardingSessionAuthenticationStatusItem || (exports.OnboardingSessionAuthenticationStatusItem = {}));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = "";
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: "same-origin",
            headers: {},
            redirect: "follow",
            referrerPolicy: "no-referrer",
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
            [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(key, property instanceof Blob
                    ? property
                    : typeof property === "object" && property !== null
                        ? JSON.stringify(property)
                        : `${property}`);
                return formData;
            }, new FormData()),
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = (_a) => __awaiter(this, void 0, void 0, function* () {
            var { body, secure, path, type, query, format, baseUrl, cancelToken } = _a, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== ContentType.FormData ? { "Content-Type": type } : {})), (requestParams.headers || {})), signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal, body: typeof body === "undefined" || body === null ? null : payloadFormatter(body) })).then((response) => __awaiter(this, void 0, void 0, function* () {
                const r = response;
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : yield response[responseFormat]()
                        .then((data) => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch((e) => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                return data;
            }));
        });
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.baseApiParams), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
}
exports.HttpClient = HttpClient;
/**
 * @title REST
 * @version v1
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.chat = {
            /**
             * No description
             *
             * @tags Attachment
             * @name AttachmentPost
             * @request POST:/chat/attachment
             */
            attachmentPost: (data, params = {}) => this.request(Object.assign({ path: `/chat/attachment`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
            /**
             * No description
             *
             * @tags AttachmentInit
             * @name AttachmentInitPost
             * @request POST:/chat/attachment/init
             */
            attachmentInitPost: (data, params = {}) => this.request(Object.assign({ path: `/chat/attachment/init`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
        };
        this.onboarding = {
            /**
             * No description
             *
             * @tags Authenticate
             * @name AuthenticatePost
             * @request POST:/onboarding/authenticate
             */
            authenticatePost: (data, params = {}) => this.request(Object.assign({ path: `/onboarding/authenticate`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
            /**
             * No description
             *
             * @tags Registration
             * @name RegistrationPost
             * @request POST:/onboarding/registration
             */
            registrationPost: (data, params = {}) => this.request(Object.assign({ path: `/onboarding/registration`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
            /**
             * No description
             *
             * @tags Screenshot
             * @name ScreenshotGet
             * @request GET:/onboarding/screenshot
             */
            screenshotGet: (query, params = {}) => this.request(Object.assign({ path: `/onboarding/screenshot`, method: "GET", query: query, format: "json" }, params)),
            /**
             * No description
             *
             * @tags ValidateEmail
             * @name ValidateEmailPost
             * @request POST:/onboarding/validate-email
             */
            validateEmailPost: (data, params = {}) => this.request(Object.assign({ path: `/onboarding/validate-email`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
        };
        this.webhook = {
            /**
             * No description
             *
             * @tags Chargebee
             * @name ChargebeePost
             * @request POST:/webhook/chargebee
             */
            chargebeePost: (params = {}) => this.request(Object.assign({ path: `/webhook/chargebee`, method: "POST" }, params)),
            /**
             * No description
             *
             * @tags Nexmo
             * @name NexmoInboundPost
             * @request POST:/webhook/nexmo/{companyId}/inbound
             */
            nexmoInboundPost: (companyId, params = {}) => this.request(Object.assign({ path: `/webhook/nexmo/${companyId}/inbound`, method: "POST" }, params)),
            /**
             * No description
             *
             * @tags Nexmo
             * @name NexmoStatusPost
             * @request POST:/webhook/nexmo/{companyId}/status
             */
            nexmoStatusPost: (companyId, params = {}) => this.request(Object.assign({ path: `/webhook/nexmo/${companyId}/status`, method: "POST" }, params)),
        };
        this.partner = {
            /**
             * No description
             *
             * @tags Company
             * @name CompaniesUpdate
             * @request PUT:/partner/companies/{companyId}
             */
            companiesUpdate: (companyId, data, params = {}) => this.request(Object.assign({ path: `/partner/companies/${companyId}`, method: "PUT", body: data, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Company
             * @name CompaniesStatusDetail
             * @request GET:/partner/companies/{companyId}/status
             */
            companiesStatusDetail: (companyId, params = {}) => this.request(Object.assign({ path: `/partner/companies/${companyId}/status`, method: "GET", format: "json" }, params)),
            /**
             * No description
             *
             * @tags Company
             * @name CompaniesSuspendUpdate
             * @request PUT:/partner/companies/{companyId}/suspend
             */
            companiesSuspendUpdate: (companyId, params = {}) => this.request(Object.assign({ path: `/partner/companies/${companyId}/suspend`, method: "PUT" }, params)),
            /**
             * No description
             *
             * @tags Company
             * @name CompaniesUnsuspendUpdate
             * @request PUT:/partner/companies/{companyId}/unsuspend
             */
            companiesUnsuspendUpdate: (companyId, params = {}) => this.request(Object.assign({ path: `/partner/companies/${companyId}/unsuspend`, method: "PUT" }, params)),
            /**
             * No description
             *
             * @tags OnboardingSession
             * @name OnboardingSessionPost
             * @request POST:/partner/onboarding-session
             */
            onboardingSessionPost: (data, params = {}) => this.request(Object.assign({ path: `/partner/onboarding-session`, method: "POST", body: data, type: ContentType.Json, format: "json" }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags Hooks
             * @name HooksPost
             * @request POST:/v1/Hooks
             */
            hooksPost: (query, params = {}) => this.request(Object.assign({ path: `/v1/Hooks`, method: "POST", query: query, format: "json" }, params)),
            /**
             * No description
             *
             * @tags Hooks
             * @name HooksDelete
             * @request DELETE:/v1/Hooks/{id}
             */
            hooksDelete: (id, params = {}) => this.request(Object.assign({ path: `/v1/Hooks/${id}`, method: "DELETE", format: "json" }, params)),
            /**
             * No description
             *
             * @tags List
             * @name UserGet
             * @request GET:/v1/user
             */
            userGet: (params = {}) => this.request(Object.assign({ path: `/v1/user`, method: "GET", format: "json" }, params)),
            /**
             * No description
             *
             * @tags List
             * @name TeamGet
             * @request GET:/v1/team
             */
            teamGet: (params = {}) => this.request(Object.assign({ path: `/v1/team`, method: "GET", format: "json" }, params)),
            /**
             * No description
             *
             * @tags List
             * @name GetV1
             * @request GET:/v1/tag
             */
            getV1: (params = {}) => this.request(Object.assign({ path: `/v1/tag`, method: "GET", format: "json" }, params)),
            /**
             * No description
             *
             * @tags Me
             * @name UserMeGet
             * @request GET:/v1/user/Me
             */
            userMeGet: (params = {}) => this.request(Object.assign({ path: `/v1/user/Me`, method: "GET" }, params)),
            /**
             * No description
             *
             * @tags Recent
             * @name ConversationsRecentGet
             * @request GET:/v1/conversations/Recent
             */
            conversationsRecentGet: (query, params = {}) => this.request(Object.assign({ path: `/v1/conversations/Recent`, method: "GET", query: query, format: "json" }, params)),
            /**
             * No description
             *
             * @tags Recent
             * @name ContactsRecentGet
             * @request GET:/v1/contacts/Recent
             */
            contactsRecentGet: (query, params = {}) => this.request(Object.assign({ path: `/v1/contacts/Recent`, method: "GET", query: query, format: "json" }, params)),
        };
    }
}
exports.Api = Api;
